const ThreeDSwiper = new Swiper('.trending-swiper', {
  effect: 'coverflow',
  grabCursor: true,
  centeredSlides: true,
  loop: true,
  slidesPerView: 'auto',
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 2.5,
    slideShadows : false,
    
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    0: {
      autoplay: false,
    },
    550: {
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 500,
        modifier: 2,
      }
    },
    1300: {
      coverflowEffect: {
        depth: 650,
        scale: 1.3,
        modifier: 2.5,
      }
    },
  }
});